/* eslint-disable import/prefer-default-export */
export const APIRespnseErrorStatusCodes = {
  400: {
    code: 400,
    message: '400 Bad Request',
  },
  401: {
    code: 401,
    message: '401 Unauthorized',
  },
  402: {
    code: 402,
    message: '402 Payment Required (Experimental)',
  },
  403: {
    code: 403,
    message:
      '403 Forbidden(seems you are not authorized of hubbers please login again & try)',
  },
  404: {
    code: 404,
    message: '404 Not Found',
  },
  405: {
    code: 405,
    message: '405 Method Not Allowed',
  },
  406: {
    code: 406,
    message: '406 Not Acceptable',
  },
  407: {
    code: 407,
    message: '407 Proxy Authentication Required',
  },
  408: {
    code: 408,
    message: '408 Request Timeout(check your network connection)',
  },
  409: {
    code: 409,
    message: '409 Conflict',
  },
  410: {
    code: 410,
    message: '410 Gone',
  },
  411: {
    code: 411,
    message: '411 Length Required',
  },
  412: {
    code: 412,
    message: '412 Precondition Failed',
  },
  413: {
    code: 413,
    message: '413 Request Entity Too Large',
  },
  414: {
    code: 414,
    message: '414 Request-URI Too Long',
  },
  415: {
    code: 415,
    message: '415 Unsupported Media Type',
  },
  416: {
    code: 416,
    message: '416 Requested Range Not Satisfiable',
  },
  417: {
    code: 417,
    message: '417 Expectation Failed',
  },
  418: {
    code: 418,
    message: '418 I’m a teapot (RFC 2324)',
  },
  420: {
    code: 420,
    message: '420 Enhance Your Calm (Twitter)',
  },
  422: {
    code: 422,
    message: '422 Unprocessable Entity (WebDAV)',
  },
  423: {
    code: 423,
    message: '423 Locked (WebDAV)',
  },
  424: {
    code: 424,
    message: '424 Failed Dependency (WebDAV)',
  },
  425: {
    code: 425,
    message: '425 Too Early (WebDAV)',
  },
  426: {
    code: 426,
    message: '426 Upgrade Required',
  },
  428: {
    code: 428,
    message: '428 Precondition Required',
  },
  431: {
    code: 431,
    message: '431 Request Header Fields Too Large',
  },
  444: {
    code: 444,
    message: '444 No Response (Nginx)',
  },
  449: {
    code: 449,
    message: '449 Retry With (Microsoft)',
  },
  450: {
    code: 450,
    message: '450 Blocked by Windows Parental Controls (Microsoft)',
  },
  451: {
    code: 451,
    message: '451 Unavailable For Legal Reasons',
  },
  499: {
    code: 499,
    message: '499 Client Closed Request (Nginx)',
  },
  500: {
    code: 500,
    message: '500 Internal Server Error',
  },
  501: {
    code: 501,
    message: '501 Not Implemented',
  },
  502: {
    code: 502,
    message: '502 Bad Gateway(Deploying API)',
  },
  504: {
    code: 504,
    message: '504 Gateway Timeout',
  },
  505: {
    code: 505,
    message: '505 HTTP Version Not Supported (Experimental)',
  },
  506: {
    code: 506,
    message: '506 Variant Also Negotiates (Experimental)',
  },
  507: {
    code: 507,
    message: '507 Insufficient Storage (WebDAV)',
  },
  508: {
    code: 508,
    message: '508 Loop Detected (WebDAV)',
  },
  510: {
    code: 510,
    message: '510 Not Extended',
  },
  511: {
    code: 511,
    message: '511 Network Authentication Required',
  },
};
